var _excluded = ["children", "disabled", "icon", "iconPosition", "monochrome", "onClick", "size", "tabIndex", "variant"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import styled from 'styled-components';
import { BUTTON_VARIANTS, PROP_DEFAULTS } from "./constants.js";
import InnerContent from "./InnerContent.js";
import ButtonStyles from "./styles.js";
var ButtonContainer = styled.button.withConfig({
  componentId: "CL__sc-h5sr5m-0"
})(["", ""], props => ButtonStyles(props));
var Button = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var {
      children = PROP_DEFAULTS.children,
      disabled = PROP_DEFAULTS.disabled,
      icon,
      iconPosition = PROP_DEFAULTS.iconPosition,
      monochrome = PROP_DEFAULTS.monochrome,
      onClick,
      size = PROP_DEFAULTS.size,
      tabIndex = PROP_DEFAULTS.tabIndex,
      variant = PROP_DEFAULTS.variant
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  /* Legacy FE components are in vanilla. This lets us fallback in case
   someone is passing a bad prop through */
  var isValidVariant = Object.values(BUTTON_VARIANTS).includes(variant);
  return /*#__PURE__*/React.createElement(ButtonContainer, _extends({
    "aria-label": icon && !children ? "".concat(icon.name) : undefined,
    disabled: disabled,
    icon: icon,
    iconOnly: icon !== undefined && !children,
    iconPosition: iconPosition,
    $monochrome: monochrome,
    onClick: onClick,
    ref: ref,
    role: "button",
    size: size,
    tabIndex: tabIndex,
    type: "button",
    variant: isValidVariant ? variant : 'primary'
  }, props), /*#__PURE__*/React.createElement(InnerContent, {
    icon: icon,
    iconPosition: iconPosition,
    size: size
  }, children));
});
export default Button;